(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nelboo-winter-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    if (customElements.get('nelboo-winter-product')) return;

    class NelbooWinterProduct extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.listenerController?.abort();
        this.initialized = false;
      }

      init() {
        if (this.initialized) return;

        const dataElement = this.querySelector('[data-nb-data]');
        if (!dataElement) return;

        try {
          this.data = JSON.parse(dataElement.textContent);
        } catch (error) {
          console.error('NELBOO: invalid product data.', error);
          return;
        }

        this.initialized = true;
        this.busy = false;
        this.needsReview = false;
        this.selections = [];

        this.form = this.querySelector('[data-nb-form]');
        this.rows = this.querySelector('[data-nb-rows]');
        this.addButton = this.querySelector('[data-nb-add]');
        this.status = this.querySelector('[data-nb-status]');
        this.recovery = this.querySelector('[data-nb-recovery]');

        this.listenerController = new AbortController();
        const listenerOptions = {
          signal: this.listenerController.signal
        };

        this.form.addEventListener(
          'submit',
          event => {
            event.preventDefault();
            event.stopPropagation();
            this.addToCart();
          },
          listenerOptions
        );

        this.addEventListener(
          'change',
          event => this.handleChange(event),
          listenerOptions
        );

        this.addEventListener(
          'click',
          event => {
            const thumbnail = event.target.closest('[data-nb-thumbnail]');

            if (thumbnail) {
              this.setMainImage(
                thumbnail.dataset.nbThumbnail,
                thumbnail.dataset.nbAlt
              );
            }
          },
          listenerOptions
        );

        this.setQuantity(1);
      }

      money(cents) {
        return new Intl.NumberFormat(this.data.locale || 'en-US', {
          style: 'currency',
          currency: this.data.currency || 'USD'
        }).format(Number(cents || 0) / 100);
      }

      announce(message) {
        this.status.textContent = message;
      }

      resolveVariant(values) {
        return this.data.variants.find(variant => {
          return (
            variant.options.length === values.length &&
            variant.options.every((value, index) => value === values[index])
          );
        });
      }

      getInitialVariant() {
        return (
          this.data.variants.find(
            variant => String(variant.id) === String(this.data.selected)
          ) ||
          this.data.variants.find(variant => variant.available) ||
          this.data.variants[0]
        );
      }

      getSelectedOffer() {
        return this.querySelector('[data-nb-offer]:checked');
      }

      setQuantity(quantity) {
        const count = Math.min(4, Math.max(1, Number(quantity) || 1));
        const initialVariant = this.getInitialVariant();

        if (!initialVariant) {
          this.announce('This product is currently unavailable.');
          this.addButton.disabled = true;
          return;
        }

        while (this.selections.length < count) {
          this.selections.push([...initialVariant.options]);
        }

        this.selections.length = count;
        this.rows.replaceChildren();

        this.selections.forEach((values, index) => {
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'nb-item';
          fieldset.dataset.nbIndex = String(index);

          const legend = document.createElement('legend');
          legend.textContent = `${this.data.itemLabel} ${index + 1}`;
          fieldset.append(legend);

          const image = document.createElement('img');
          image.dataset.nbRowImage = '';
          image.width = 64;
          image.height = 80;
          image.hidden = true;
          fieldset.append(image);

          this.data.options.forEach((option, optionIndex) => {
            const label = document.createElement('label');
            label.textContent = option.name;

            const select = document.createElement('select');
            select.dataset.nbOption = String(optionIndex);
            select.setAttribute(
              'aria-label',
              `${option.name} — ${this.data.itemLabel} ${index + 1}`
            );

            option.values.forEach(value => {
              const optionElement = document.createElement('option');
              optionElement.value = value;
              optionElement.textContent = value;
              select.append(optionElement);
            });

            select.value = values[optionIndex];
            label.append(select);
            fieldset.append(label);
          });

          const price = document.createElement('p');
          price.className = 'nb-item-price';
          price.dataset.nbRowPrice = '';
          fieldset.append(price);

          this.rows.append(fieldset);
        });

        this.refresh();
      }

      handleChange(event) {
        if (event.target.matches('[data-nb-offer]')) {
          this.setQuantity(event.target.value);
          return;
        }

        if (!event.target.matches('[data-nb-option]')) return;

        const row = event.target.closest('[data-nb-index]');
        const rowIndex = Number(row.dataset.nbIndex);
        const optionIndex = Number(event.target.dataset.nbOption);
        const newValue = event.target.value;

        this.selections[rowIndex][optionIndex] = newValue;

        let variant = this.resolveVariant(this.selections[rowIndex]);

        if (!variant?.available) {
          const replacement = this.data.variants.find(candidate => {
            return (
              candidate.available &&
              candidate.options[optionIndex] === newValue &&
              candidate.options
                .slice(0, optionIndex)
                .every(
                  (value, index) =>
                    value === this.selections[rowIndex][index]
                )
            );
          });

          if (replacement) {
            this.selections[rowIndex] = [...replacement.options];

            row.querySelectorAll('[data-nb-option]').forEach(select => {
              select.value =
                replacement.options[Number(select.dataset.nbOption)];
            });

            variant = replacement;

            this.announce(
              'The configuration was adjusted to an available option. ' +
              'Please review your selection.'
            );
          } else {
            this.announce(
              'This combination is unavailable. Please choose another option.'
            );
          }
        } else {
          this.announce('');
        }

        this.refresh();

        if (variant?.image) {
          this.setMainImage(variant.image, variant.imageAlt);
        }

        if (rowIndex === 0 && variant) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      setMainImage(source, alt) {
        const image = this.querySelector('[data-nb-main-image]');
        if (!image || !source) return;

        image.src = source;
        image.removeAttribute('srcset');
        image.alt = alt || this.data.title;
        image.hidden = false;

        const placeholder = this.querySelector('[data-nb-placeholder]');
        if (placeholder) placeholder.hidden = true;
      }

      refresh() {
        const variants = this.selections.map(values =>
          this.resolveVariant(values)
        );

        Array.from(this.rows.children).forEach((row, rowIndex) => {
          const variant = variants[rowIndex];

          row.querySelectorAll('[data-nb-option]').forEach(select => {
            const optionIndex = Number(select.dataset.nbOption);

            Array.from(select.options).forEach(option => {
              const available = this.data.variants.some(candidate => {
                return (
                  candidate.available &&
                  candidate.options[optionIndex] === option.value &&
                  candidate.options
                    .slice(0, optionIndex)
                    .every(
                      (value, index) =>
                        value === this.selections[rowIndex][index]
                    )
                );
              });

              option.disabled = !available;
            });
          });

          row.querySelector('[data-nb-row-price]').textContent =
            variant?.available
              ? this.money(variant.price)
              : 'Unavailable combination';

          const image = row.querySelector('[data-nb-row-image]');
          image.hidden = !variant?.image;

          if (variant?.image) {
            image.src = variant.image;
            image.alt = variant.imageAlt || variant.title;
          }
        });

        const firstVariant = variants[0];

        this.querySelector('[data-nb-unit-price]').textContent =
          firstVariant ? this.money(firstVariant.price) : 'Unavailable';

        const compare = this.querySelector('[data-nb-unit-compare]');
        const showCompare = Boolean(
          this.data.showCompare &&
          firstVariant &&
          firstVariant.compare > firstVariant.price
        );

        compare.hidden = !showCompare;
        compare.textContent = showCompare
          ? this.money(firstVariant.compare)
          : '';

        const subtotal = variants.reduce(
          (sum, variant) => sum + Number(variant?.price || 0),
          0
        );

        const selectedOffer = this.getSelectedOffer();

        const percentage = this.data.discountsVerified
          ? Math.min(
              100,
              Math.max(0, Number(selectedOffer?.dataset.percent || 0))
            )
          : 0;

        const estimatedTotal = Math.round(
          subtotal * (100 - percentage) / 100
        );

        this.querySelector('[data-nb-total]').textContent =
          this.money(percentage ? estimatedTotal : subtotal);

        this.querySelector('[data-nb-total-label]').textContent =
          percentage ? 'Estimated subtotal' : 'Subtotal';

        const before = this.querySelector('[data-nb-before]');
        before.hidden = percentage === 0;
        before.textContent = percentage ? this.money(subtotal) : '';

        this.querySelector('[data-nb-price-note]').textContent =
          percentage ? this.data.discountNote : this.data.priceNote;

        this.querySelectorAll('[data-nb-offer]').forEach(input => {
          const quantity = Number(input.value);
          const base = Number(firstVariant?.price || 0) * quantity;

          const discount = this.data.discountsVerified
            ? Math.min(100, Math.max(0, Number(input.dataset.percent || 0)))
            : 0;

          const total = Math.round(base * (100 - discount) / 100);

          input
            .closest('.nb-offer')
            .querySelector('[data-nb-offer-price]')
            .textContent = this.money(total);
        });

        this.querySelector('[data-nb-variant-id]').value =
          firstVariant?.id || '';

        const valid =
          variants.length > 0 &&
          variants.every(variant => variant?.available);

        this.addButton.disabled =
          !valid || this.busy || this.needsReview;
      }

      buildCartItems() {
        const variants = this.selections.map(values =>
          this.resolveVariant(values)
        );

        if (
          variants.length === 0 ||
          variants.some(variant => !variant?.available)
        ) {
          throw new Error(
            'Choose an available configuration for every shawl.'
          );
        }

        const quantities = new Map();

        variants.forEach(variant => {
          quantities.set(
            variant.id,
            (quantities.get(variant.id) || 0) + 1
          );
        });

        return Array.from(quantities, ([id, quantity]) => ({
          id,
          quantity
        }));
      }

      async request(url, options = {}) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 25000);

        try {
          const response = await fetch(url, {
            ...options,
            signal: controller.signal
          });

          const data = await response.json();

          return {
            ok: response.ok,
            status: response.status,
            data
          };
        } finally {
          clearTimeout(timeout);
        }
      }

      validSections(result, definitions) {
        return definitions.every(definition => {
          const markup = result.sections?.[definition.id];

          if (typeof markup !== 'string') return false;

          const documentFragment = new DOMParser().parseFromString(
            markup,
            'text/html'
          );

          return Boolean(
            documentFragment.querySelector(
              definition.selector || '.shopify-section'
            )
          );
        });
      }

      async addToCart() {
        if (this.busy || this.needsReview) return;

        let items;

        try {
          items = this.buildCartItems();
        } catch (error) {
          this.announce(error.message);
          return;
        }

        const drawer = document.querySelector('cart-drawer');

        if (
          !drawer ||
          typeof drawer.getSectionsToRender !== 'function' ||
          typeof drawer.renderContents !== 'function'
        ) {
          this.announce(
            'The cart is temporarily unavailable. ' +
            'Please contact us or try again later.'
          );
          return;
        }

        const definitions = drawer.getSectionsToRender();
        const sectionIds = definitions.map(definition => definition.id);

        this.busy = true;
        this.refresh();
        this.form.setAttribute('aria-busy', 'true');
        this.addButton.textContent = 'Adding…';
        this.announce('');

        if (typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(this.addButton);
        }

        let requestSent = false;
        let added = false;
        let rejection = '';

        try {
          requestSent = true;

          const response = await this.request(
            `${this.data.root}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items,
                sections: sectionIds,
                sections_url: window.location.pathname
              })
            }
          );

          if (!response.ok) {
            rejection =
              typeof response.data.description === 'string'
                ? response.data.description
                : 'These items could not be added.';

            throw new Error(rejection);
          }

          added = true;
          const result = response.data;

          /*
            A section-rendering failure does not mean the cart add failed.
            Refresh sections with a GET, never repeat the POST.
          */
          if (!this.validSections(result, definitions)) {
            const refreshUrl = new URL(window.location.href);

            refreshUrl.searchParams.set(
              'sections',
              sectionIds.join(',')
            );

            const refreshed = await this.request(
              refreshUrl.toString(),
              {
                headers: {
                  Accept: 'application/json'
                }
              }
            );

            if (!refreshed.ok) {
              throw new Error('Cart display could not refresh.');
            }

            result.sections = refreshed.data;
          }

          if (!this.validSections(result, definitions)) {
            throw new Error('Cart display could not refresh.');
          }

          drawer.classList.remove('is-empty');
          drawer.renderContents(result);

          this.announce('Added to your cart.');

          /*
            No duplicate Meta Pixel call is sent here.
            The store's existing analytics integration remains responsible.
          */
          this.dispatchEvent(
            new CustomEvent('nelboo:cart-added', {
              bubbles: true,
              detail: {
                items,
                result
              }
            })
          );
        } catch (error) {
          if (requestSent) {
            /*
              A failed or interrupted request can leave the cart uncertain.
              Prevent accidental duplicate adds until the cart is reviewed.
            */
            this.needsReview = true;
            this.recovery.hidden = false;

            if (added) {
              this.announce(
                'Your items were added, but the cart display could not ' +
                'refresh. Open your cart to review them before adding again.'
              );
            } else {
              this.announce(
                (rejection ? `${rejection} ` : '') +
                'We could not confirm the cart update. ' +
                'Please review your cart before trying again.'
              );
            }
          } else {
            this.announce(
              error.message || 'Please try again.'
            );
          }
        } finally {
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          this.addButton.textContent = this.data.addLabel;
          this.refresh();
        }
      }
    }

    customElements.define(
      'nelboo-winter-product',
      NelbooWinterProduct
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
